export const isEmpty = (value) => !value || value.trim() === '';

export const exceedsLimit = (value, limit) =>
  typeof value === 'string' && value.trim().length > limit;
